import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { WarningIcon } from '../../../vectors/index';
import { setCookie } from '@utils/getCookie';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
type ConfirmationModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmationModal = ({
  open,
  onConfirm,
  onCancel,
}: ConfirmationModalProps) => {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={onCancel}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <WarningIcon />
        <br />
        <Typography variant="h4" fontWeight="bold" color="warning.main">
          WARNING!
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ color: 'text.secondary', pb: 2 }}>
        <List dense>
          <ListItem sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }} disableGutters>
            <ListItemText primaryTypographyProps={{ fontSize: '18px', margin: '0 auto', textAlign: 'center', maxWidth: '600px' }} sx={{ textAlign: 'center', fontSize: '18px' }} primary="Editing this template in any way will edit all attached companies and revert all jobs, hiring statuses, and application questions to match this template." />
          </ListItem>
          <ListItem alignItems="flex-start" disableGutters>
            <ListItemIcon sx={{ minWidth: 18 }}>
              <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
            </ListItemIcon>
            <ListItemText primary="To edit only one location, navigate to Manage Companies and edit the information there." />
          </ListItem>
          <ListItem alignItems="flex-start" disableGutters>
            <ListItemIcon sx={{ minWidth: 18 }}>
              <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
            </ListItemIcon>
            <ListItemText primary="To create a new location with your edits — which won't affect your current companies — create a new template and add the new company to the new template." />
          </ListItem>
        </List>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1, flexDirection: 'column' }}>
        <Stack direction="row" gap={1} spacing={2} sx={{ flexWrap: 'wrap' }}>
          <Button size='small' sx={{ fontSize: '14px', width: '160px' }} variant="contained" color="primary" onClick={onConfirm}>
            Continue My Edit
          </Button>
          <Button
            size='small'
            variant="outlined"
            onClick={() => navigate('/enterprise/companies/')}
            sx={{ fontSize: '14px', width: '160px' }}
          >
            Manage Companies
          </Button>
          <Button
            variant="outlined"
            size='small'
            sx={{ fontSize: '14px', width: '160px' }}
            onClick={() =>
              navigate('/enterprise/templates/', {
                state: { addnewTemplete: true },
              })
            }
          >
            Create New Template
          </Button>
        </Stack>
        <Typography
          onClick={() => {
            setCookie('dontShowWarningPopup', 'true', 5);
            onCancel();
          }}
          sx={{ cursor: 'pointer' }}
          mb={2}
          mt={3}
          alignSelf="center"
          variant="caption"
          color={grey[600]}
        >
          Do not show this again
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;